import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getAnalytics, isSupported } from 'firebase/analytics'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyCmxYLbh501AZTR4TMMlAcgUxioxX_yEBI",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "total-rewards-pro.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "total-rewards-pro",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "total-rewards-pro.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "208619389790",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:208619389790:web:6f67a62e117d299c59c5cf",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-W69NSEWCXT"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase services
export const db = getFirestore(app)
export const auth = getAuth(app)

// Initialize Analytics (only in browser environment)
let analytics = null
if (typeof window !== 'undefined') {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app)
    }
  })
}

export { analytics }
export default app 